module.exports = __webpack_public_path__ + "assets/terms/termos-mx.01afb49f.pdf";